import AdmissionsBodyComponent from "./admissionsBodyComponent";
import NavigationBar from "../navigation/nav-bar/navigationBar";
import FooterComponent from "../navigation/footer/footerComponent";


export default function MainAdmissionsComponent() {

    return (
        <div>
            <NavigationBar transparent />
            <AdmissionsBodyComponent />
            <FooterComponent />
        </div>
    )
}